import { chartConfig } from "../chart.commonConfig";
import { PATHS, PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const FIRST_PIE_CHART_DASHBOARD_HELPER = (
  data,
  history,
  checkedValue,
  user
) => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      className: "chart-background first-pie-graph",
      spacingBottom: 10,
      spacingRight: 0,
      spacingLeft: 0,
      animation: {
        duration: 9000
      },
      //height: 400,
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.FIRST._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: "",
      useHTML: false,
      verticalAlign: "middle",
      y: -10,
      style: { color: "#000000", fontSize: "38px", "font-family": "mpb" }
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 20,
      text: "",
      align: "center",
      verticalAlign: "middle",
      style: {
        color: "#000000",
        fontSize: "12px",
        "font-family": "mpr",
        fontWeight: "300"
      }
    },
    plotOptions: {
      series: {
        animation: true,
        duration: 9000
      },
      pie: {
        showInLegend: true,
        shadow: true,
        states: {
          hover: {
            enabled: true
          },
          inactive: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true,
          //alignTo: "plotEdges",
          distance: -30,
          style: {
            color: "white"
          },
          className: "data-label-text"
        },

        cursor: "pointer",
        allowPointSelect: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            },
            click: function(event) {
              history.push({
                pathname: PATHS.PROJECT_LIST,
                isDashBoard: true,
                summaryDataBy: false,
                state: {
                  groupCategory: "CENTRAL",
                  sponsoringMinistry:
                    user && user.groupCategory === "CENTRAL"
                      ? [
                          {
                            displayName: user.groupName,
                            key: user.groupId.toString()
                          }
                        ]
                      : null,
                  projectStage: [
                    {
                      displayName: "VERIFIED",
                      key: "VERIFIED"
                    }
                  ],
                  projectFlags: checkedValue
                    ? [
                        {
                          displayName: "MARCH 24",
                          key: "MARCH 24"
                        }
                      ]
                    : null,
                  projectTags:
                    this.name === "Commissioned"
                      ? [
                          {
                            displayName: "COMMISSIONED",
                            key: "COMMISSIONED"
                          }
                        ]
                      : this.name === "Under Implementation"
                      ? [
                          {
                            displayName: "NOT COMMISSIONED",
                            key: "NOT COMMISSIONED"
                          }
                        ]
                      : null
                }
              });
            }
          }
        }
      }
    },
    series: [
      {
        type: "pie",
        name: "Issues",
        data: [],
        size: "90%",
        innerSize: "50%",
        depth: 50,
        // startAngle: 90,
        dataLabels: {
          enabled: true,
          color: "black",
          style: {
            color: "black"
          },
          format: `<span style="color:{"black"}">{point.y}</span>`
        }
      }
    ],
    legend: {
      enabled:
        data && (data[1].count === 0 && data[0].count === 0) ? false : true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      floating: false,
      alignColumns: false,
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      padding: 2,
      itemMarginTop: 0,
      itemMarginBottom: 2,
      itemWidth: 200,
      margin: 40,
      itemStyle: {
        lineHeight: "18px",
        color: "#2E384D",
        "font-family": "mpr",
        fontSize: "17px",
        fontWeight: "300",
        textOverflow: "clip"
      }
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Projects: ${this.y}</b>
              `;
      },
      style: {
        fontSize: "17px"
      }
    }
  };

  try {
    // set data
    let totalActiveProjects = 0;
    PieChartConfig.series[0]["data"] = (data || []).map((val, index) => {
      val.name =
        val.name === "UNDER CONSTRUCTION / UNDER IMPLEMENTATION" ||
        val.name === "Under Implementation"
          ? "Under Implementation"
          : "Commissioned";
      totalActiveProjects = totalActiveProjects + val.count;
      return { name: val.name, y: val.count };
    });
    //PieChartConfig.title.text = `UNDER CONSTRUCTION / UNDER IMPLEMENTATION : ${totalActiveProjects} PROJECTS`;
    PieChartConfig.title.text = `${totalActiveProjects}`;
    //PieChartConfig.subtitle.text = `Implementation mode within ${totalActiveProjects} PMG monitored projects`;
    //PieChartConfig.subtitle.text = `TOTAL PROJECTS`;
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
